/* eslint-disable no-unused-vars */
import { ChevronDown, ChevronUp } from 'lucide-react'
import { useEffect, useState } from 'react'
import {
  Button,
  Card,
  Col,
  Collapse,
  Container,
  Form,
  Modal,
  Row
} from 'react-bootstrap'
import { useLocation, useParams, useSearchParams } from 'react-router-dom'
import Swal from 'sweetalert2'
import CustomButton from '../../../components/Button/CustomButton'
import ModalAddUpdateItem from '../../../components/modal/Sj/ModalAddUpdateItem'
import ModalSelectFormat from '../../../components/modal/Sj/ModalSelectFormat'
import ModalSolveContinueTicket from '../../../components/modal/Sj/ModalSolveContinueTicket'
import api from '../../../config/AxiosInstance'
import * as Common from '../../../utils/Common'
import { firstLetterUpperCase } from '../../../utils/TextFormatter'
import Loading from '../../../components/atoms/Loading'
import ModalUpdateRequest from '../../../components/modal/Sj/ModalUpdateRequest'
import ModalStockAdjustment from '../../../components/modal/stockAdjustment/ModalStockAdjustment'
import AlertIcon from '../../../components/atoms/Icons/AlertIcon'
import CustomCloseButton from '../../../components/Button/CustomCloseButton'
import GeneralInfo from './components/GeneralInfo'
import RequestTable from './components/RequestTable'
import PickupCommandTable from './components/PickupCommandTable'
import ProgressDetail from './components/ProgressDetail'
import DetailMetadata from './components/DetailMetadata'
import DetailHeader from './components/DetailHeader'
import { cardStyle } from './components/constants'

const Detail = () => {
  const [openCommand, setOpenCommand] = useState(true)
  const [isLoading, setIsLoading] = useState(false)
  const [loadingSendToErp, setLoadingSendToErp] = useState(false)
  const [detail, setDetail] = useState({})
  const [requestCommand, setRequestCommand] = useState([])
  const [pickupCommand, setPickupCommand] = useState([])
  const [progressDetailCommand, setProgressDetailCommand] = useState(true)
  const [showModalDeleteRequest, setShowModalDeleteRequest] = useState(false)
  const [selectedRequest, setSelectedRequest] = useState(null)
  const { pathname } = useLocation()
  const headMenu = pathname.split('/')[1]
  const poHeadMenu = pathname.split('/')[2]
  const routeValue = `${headMenu}/${poHeadMenu}`
  const [showModalAddUpdateItem, setShowModalAddUpdateItem] = useState(false)
  const { id } = useParams()
  const [searchParams, setSearchParams] = useSearchParams()
  const [showModalSolveContinueTicket, setShowModalSolveContinueTicket] =
    useState(false)
  const [showModalUpdateRequest, setShowModalUpdateRequest] = useState(false)
  const [loadingDeleteRequest, setLoadingDeleteRequest] = useState(false)
  const [loadingDownloadPrint, setLoadingDownloadPrint] = useState({
    coaDownload: false,
    coaPrint: false,
    sjDownload: false,
    sjPrint: false
  })
  const [submitSolveContinueTicket, setSubmitSolveContinueTicket] =
    useState(false)
  const [editData, setEditData] = useState({
    type: 'create',
    command_id: null,
    item_code: null,
    item_alias: null,
    item_batch_id: null,
    total_pack: null,
    exp_date: null,
    qty: 0
  })
  const [showModalSelectFormat, setShowModalSelectFormat] = useState(false)
  const [selectFormatDownload, setSelectFormatDownload] = useState({
    type: 'sj',
    format: null,
    action: null,
    id: null
  })
  const [loadingFormat, setLoadingFormat] = useState(false)
  const [updateRequest, setUpdateRequest] = useState({
    request_id: '',
    sjDraftId: '',
    sjCode: '',
    item_id: '',
    item_name: '',
    item_alias: '',
    batch_id: '',
    slot_id: '',
    batch: '',
    slot: '',
    qty: 0,
    total_pack: 0,
    warehouse: null,
    item_code: ''
  })

  const loadData = async (id) => {
    try {
      setIsLoading(true)
      const res = await api.get(`outbound/sjdraft/show?sj=${id}`)
      const { data } = res.data
      setDetail(data)
      setRequestCommand(data.command)
      setPickupCommand(data.pickup_command)
      setUpdateRequest((prevUpdateRequest) => ({
        ...prevUpdateRequest,
        warehouse: data?.src || '',
        sjDraftId: data?.id || '',
        sjCode: data?.draft_code || ''
      }))
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    } finally {
      setIsLoading(false)
    }
  }

  const handleDownloadPrint = async (type, typeAction, id) => {
    try {
      if (type !== 'sj') {
        setLoadingDownloadPrint((loadingDownloadPrint) => ({
          ...loadingDownloadPrint,
          [type + firstLetterUpperCase(typeAction)]: true
        }))
      } else {
        setLoadingFormat(true)
      }

      if (type === 'sj') {
        const res = await api.get(
          `outbound/sjdraft/file-sj/${id}?print=${encodeURIComponent(
            selectFormatDownload?.format
          )}&action=${typeAction}`,
          {
            responseType: typeAction === 'print' ? 'text' : 'arraybuffer'
          }
        )
        const { status, data, headers } = res
        if (status === 200) {
          const contentType = headers?.['content-type'] || ''
          if (typeAction === 'print') {
            if (contentType.includes('text/html') || typeof data === 'string') {
              Common.printDocument(data, true)
            } else {
              const blob = new Blob([data], { type: 'application/pdf' })
              Common.printDocument(blob)
            }
          } else if (typeAction === 'download') {
            const blob = new Blob([data], { type: 'application/pdf' })
            const url = window.URL.createObjectURL(blob)
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', `file-sj-${id}.pdf`)
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            window.URL.revokeObjectURL(url)
          }
        }
      }
      if (type === 'coa') {
        const res = await api.get(`/outbound/sjdraft/file-coa/${id}`, {
          responseType: 'arraybuffer'
        })
        const { status, data } = res
        if (status === 200) {
          const blob = new Blob([data], { type: 'application/pdf' })
          const url = window.URL.createObjectURL(blob)
          if (typeAction === 'download') {
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', `file-coa-${id}.pdf`)
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            window.URL.revokeObjectURL(url)
          }
          if (typeAction === 'print') {
            Common.printPdf(blob)
          }
        }
      }
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    } finally {
      if (type === 'sj') {
        setLoadingFormat(false)
        setShowModalSelectFormat(false)
        setSelectFormatDownload((prevSelectFormatDownload) => ({
          ...prevSelectFormatDownload,
          id: null,
          format: null
        }))
      } else {
        setLoadingDownloadPrint((loadingDownloadPrint) => ({
          ...loadingDownloadPrint,
          [type + firstLetterUpperCase(typeAction)]: false
        }))
      }
    }
  }

  const handleSubmitSolveContinueTicket = async (type = 'direct') => {
    try {
      setSubmitSolveContinueTicket(true)
      const solvedPickupCommands = pickupCommand
        .filter((item) => !item.is_new_command)
        .map((item) => ({
          command_id: item.command_id
        }))

      const newPickupCommands = pickupCommand
        .filter((item) => item.is_new_command)
        .map((item) => ({
          command_id: null,
          item_code: item.item_code,
          batch: item.batch,
          location: item.location,
          total_pack: item.total_pack,
          item_alias: item.item_alias
        }))

      const newSlotLocations = pickupCommand
        .filter((item) => item.is_new_command)
        .map((item) => ({
          need_qty: Number(item.total_pack) || 0,
          available_qty: Number(item.total_pack) || 0,
          item_batch: item.batch,
          items: [
            {
              item_name: item.item_name,
              item_alias: item.item_alias || null,
              item_code: item.item_code,
              batch: item.batch,
              qty: Number(item.total_pack) || 0,
              uom: item.uom || 'Kg',
              uom_pack: item.uom_pack,
              location: item.location
            }
          ]
        }))

      const payload = {
        pickup_command: [...solvedPickupCommands, ...newPickupCommands],
        slot_locations: [...(detail?.slot_locations || []), ...newSlotLocations]
      }

      const res = await api.post(
        `outbound/sjdraft/${detail?.id}/solve-problem`,
        payload
      )
      if (res.data.success) {
        loadData(id)
      }
    } catch (error) {
      const err = error?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(err)
    } finally {
      setSubmitSolveContinueTicket(false)
      if (type === 'modal') {
        setShowModalSolveContinueTicket(false)
      }
    }
  }

  const handleDeleteAddItemPickupCommand = (commandId) => {
    setPickupCommand((prev) =>
      prev.filter((item) => item.command_id !== commandId)
    )
  }

  const handleCreateWorkOrder = (item) => {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-primary-orange',
        cancelButton: 'btn btn-transparent',
        actions:
          'd-flex w-100 justify-content-end pt-4 ps-4 pe-4 separator-border-action-sweetalert'
      },
      buttonsStyling: false
    })
    swalWithBootstrapButtons
      .fire({
        title: 'Create Work Order?',
        text: 'Create work order for this item alias?',
        icon: 'warning',
        iconColor: '#828282',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Create',
        cancelButtonText: 'Cancel',
        allowOutsideClick: false,
        reverseButtons: true,
        showCloseButton: true
      })
      .then(async (result) => {
        if (result.isConfirmed) {
          createWorkOrder(item)
        } else {
          return false
        }
      })
  }

  const handleSendToErp = () => {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-primary-orange',
        cancelButton: 'btn btn-transparent',
        actions:
          'd-flex w-100 justify-content-end pt-4 ps-4 pe-4 separator-border-action-sweetalert'
      },
      buttonsStyling: false
    })
    swalWithBootstrapButtons
      .fire({
        title: 'Send to ERP?',
        text: 'This action can’t be repeated!',
        icon: 'warning',
        iconColor: '#828282',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Send!',
        cancelButtonText: 'Cancel',
        allowOutsideClick: false,
        reverseButtons: true,
        showCloseButton: true
      })
      .then(async (result) => {
        if (result.isConfirmed) {
          sendToErp()
        } else {
          return false
        }
      })
  }

  const sendToErp = async () => {
    try {
      setLoadingSendToErp(true)
      const res = await api.post(`outbound/sjdraft/${detail?.id}/send-erp`)
      const { data } = res
      if (data.success) {
        Swal.fire({
          icon: 'success',
          title: 'Success',
          text: 'Send to erp success'
        })
      }
    } catch (error) {
      const err = error?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(err)
    } finally {
      setLoadingSendToErp(false)
      loadData(id)
    }
  }

  const createWorkOrder = async (item) => {
    try {
      const body = {
        sj: id,
        command: item
      }
      const res = await api.post('/outbound/work-order', body)
      const { data } = res
      if (data.success) {
        Swal.fire({
          icon: 'success',
          title: 'Success',
          text: 'Create work order success'
        })
      }
    } catch (error) {
      const err = error?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(err)
    } finally {
      loadData(id)
    }
  }

  const handleUpdateRequest = (
    itemCode = null,
    itemName = null,
    itemAlias = null,
    requestId = null
  ) => {
    const show = !showModalUpdateRequest
    setShowModalUpdateRequest(show)
    if (show && itemCode) {
      setUpdateRequest((prevUpdateRequest) => ({
        ...prevUpdateRequest,
        item_code: itemCode,
        item_name: itemName,
        item_alias: itemAlias,
        request_id: requestId
      }))
    } else {
      setUpdateRequest((prevUpdateRequest) => ({
        ...prevUpdateRequest,
        item_id: '',
        item_name: '',
        item_alias: '',
        request_id: '',
        batch_id: '',
        slot_id: '',
        batch: '',
        slot: '',
        qty: 0,
        total_pack: 0,
        item_code: ''
      }))
    }
  }

  const handleDeleteRequest = async () => {
    try {
      setLoadingDeleteRequest(true)
      const res = await api.delete(
        `/outbound/sjdraft/${updateRequest.sjDraftId}/so/${selectedRequest}`
      )
      const { data } = res
      if (data.success) {
        Common.showPopUpSuccessMessage('Successfully deleted request')
        loadData(id)
        setShowModalDeleteRequest(false)
        setSelectedRequest(null)
      }
    } catch (error) {
      const err =
        error?.response?.data?.errors?.message ||
        error?.message ||
        'An error occurred'
      Common.showPopUpErrorMessage(err)
    } finally {
      setLoadingDeleteRequest(false)
    }
  }

  useEffect(() => {
    loadData(id)
  }, [id])

  if (isLoading) {
    return <Loading />
  }

  return (
    <>
      <Container className="mb-5">
        <Row>
          <DetailHeader
            detail={detail}
            searchParams={searchParams}
            submitSolveContinueTicket={submitSolveContinueTicket}
            setShowModalSolveContinueTicket={setShowModalSolveContinueTicket}
            handleSubmitSolveContinueTicket={handleSubmitSolveContinueTicket}
            loadingDownloadPrint={loadingDownloadPrint}
            handleDownloadPrint={handleDownloadPrint}
            setShowModalSelectFormat={setShowModalSelectFormat}
            setSelectFormatDownload={setSelectFormatDownload}
          />
        </Row>
        <Row className="mt-3">
          <Form>
            <GeneralInfo detail={detail} />
            <Card style={cardStyle}>
              <div
                className="d-flex justify-content-between align-items-center cursor-pointer mb-3"
                onClick={() => {
                  setOpenCommand(!openCommand)
                }}
                style={{ cursor: 'pointer' }}
              >
                <h5 className="m-0 fw-bold">COMMAND</h5>
                <Button variant="transparent" className="p-0 text-secondary">
                  {openCommand ? (
                    <ChevronUp size={16} />
                  ) : (
                    <ChevronDown size={16} />
                  )}
                </Button>
              </div>
              <Collapse in={openCommand}>
                <div id="example-collapse-text2">
                  <Row>
                    <Col md={12} className="mt-3">
                      <div className="d-flex gap-3 justify-content-between mb-3">
                        <div className="d-flex align-items-center">
                          <h6 className="text-secondary">REQUEST</h6>
                        </div>
                        <Button
                          variant="transparent"
                          className={
                            ['done', 'unassigned'].includes(
                              detail?.draft_status
                            )
                              ? 'btn-primary-orange opacity-25'
                              : 'btn-primary-orange'
                          }
                          disabled={['done', 'unassigned'].includes(
                            detail?.draft_status
                          )}
                          onClick={() => handleUpdateRequest()}
                        >
                          Add
                        </Button>
                      </div>
                      <div className="table-responsive">
                        <RequestTable
                          requestCommand={requestCommand}
                          detail={detail}
                          handleUpdateRequest={handleUpdateRequest}
                          setShowModalDeleteRequest={setShowModalDeleteRequest}
                          setSelectedRequest={setSelectedRequest}
                        />
                      </div>
                    </Col>
                    {!detail?.is_cross_dock &&
                      !detail?.is_external &&
                      !detail?.is_consignment && (
                        <>
                          <Col md={12}>
                            <div className="text-muted d-flex gap-2">
                              <div
                                style={{
                                  backgroundColor: '#8FC9FF',
                                  height: '15px',
                                  width: '15px',
                                  marginTop: '.2rem'
                                }}
                              ></div>
                              <span className="ml-2">Need Extend</span>
                            </div>
                          </Col>
                          <Col md={12} className="mt-3">
                            <Row className="mb-2">
                              <Col md={6}>
                                <h6 className="text-secondary mb-3">
                                  PICK UP COMMAND
                                </h6>
                              </Col>
                              {detail?.draft_status === 'problem' && (
                                <Col md={6}>
                                  <div
                                    className="d-flex flex-row justify-content-end"
                                    style={{ marginTop: '-0.5rem' }}
                                  >
                                    <CustomButton
                                      variant={'transparent'}
                                      style={{ backgroundColor: '#F89D1D' }}
                                      text={'Add'}
                                      onClick={() => {
                                        setEditData({
                                          type: 'create',
                                          command_id: null,
                                          item_code: null,
                                          item_alias: null,
                                          item_batch_id: null,
                                          total_pack: null,
                                          exp_date: null,
                                          qty: 0
                                        })
                                        setShowModalAddUpdateItem(true)
                                      }}
                                    />
                                  </div>
                                </Col>
                              )}
                            </Row>

                            <div className="table-responsive">
                              <PickupCommandTable
                                pickupCommand={pickupCommand}
                                detail={detail}
                                routeValue={routeValue}
                                setShowModalAddUpdateItem={
                                  setShowModalAddUpdateItem
                                }
                                setEditData={setEditData}
                                handleCreateWorkOrder={handleCreateWorkOrder}
                                handleDeleteAddItemPickupCommand={
                                  handleDeleteAddItemPickupCommand
                                }
                              />
                            </div>
                          </Col>
                          <Col md={12}>
                            <Row>
                              <Col md={6}>
                                <div className="text-muted d-flex gap-2">
                                  <div
                                    style={{
                                      backgroundColor: '#FF8F8F',
                                      height: '15px',
                                      width: '15px',
                                      marginTop: '.2rem'
                                    }}
                                  ></div>
                                  <span className="ml-2 mb-3">
                                    Less Items Alias
                                  </span>
                                </div>
                              </Col>
                            </Row>
                          </Col>
                        </>
                      )}
                  </Row>
                </div>
              </Collapse>
            </Card>
            {detail?.is_finish_loading && !detail?.erp?.erp_status && (
              <>
                <Row className="mb-3">
                  <Col md={6} hidden={!detail?.erp?.err_notes ? true : false}>
                    <p>
                      {detail?.erp?.description}, status:
                      <span
                        style={{
                          color:
                            detail?.erp?.erp_status === true
                              ? 'green'
                              : '#C12727'
                        }}
                        className="ms-2 fw-bold text-uppercase"
                      >
                        {detail?.erp?.erp_status === true
                          ? 'Success'
                          : 'Failed'}
                      </span>
                    </p>
                    <div className="d-flex flex-row gap-2">
                      <span>Failed Reason: </span>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: detail?.erp?.err_notes
                        }}
                      ></div>
                    </div>
                  </Col>
                  <Col
                    md={!detail?.erp?.err_notes ? 12 : 6}
                    className="d-flex flex-row justify-content-end"
                  >
                    <div className="d-flex flex-column justify-content-center">
                      <CustomButton
                        variant={!loadingSendToErp ? 'warning' : 'secondary'}
                        text={!loadingSendToErp ? 'Send to ERP' : 'Sending...'}
                        onClick={() => handleSendToErp()}
                        disabled={loadingSendToErp}
                        classNameValue={`text-white ${
                          loadingSendToErp ? 'opacity-25' : ''
                        }`}
                      />
                    </div>
                  </Col>
                </Row>
                <div
                  style={{ height: '1rem', borderTop: '2px solid #F1F2F7' }}
                ></div>
              </>
            )}

            <ProgressDetail
              detail={detail}
              progressDetailCommand={progressDetailCommand}
              setProgressDetailCommand={setProgressDetailCommand}
            />
            <DetailMetadata detail={detail} />
          </Form>
        </Row>

        <ModalSolveContinueTicket
          show={showModalSolveContinueTicket}
          onHide={() => setShowModalSolveContinueTicket(false)}
          handleSubmitSolveContinueTicket={() =>
            handleSubmitSolveContinueTicket('modal')
          }
          submitSolveContinueTicket={submitSolveContinueTicket}
        />

        <ModalSelectFormat
          show={showModalSelectFormat}
          handleClose={() => {
            setShowModalSelectFormat(false)
            setSelectFormatDownload((prevSelectFormatDownload) => ({
              ...prevSelectFormatDownload,
              id: null,
              format: null
            }))
          }}
          setSelectFormatDownload={setSelectFormatDownload}
          selectFormatDownload={selectFormatDownload}
          handleDownloadPrint={handleDownloadPrint}
          loadingFormat={loadingFormat}
        />

        <ModalAddUpdateItem
          show={showModalAddUpdateItem}
          onHide={() => setShowModalAddUpdateItem(false)}
          data={editData}
          reportPickupCommand={pickupCommand?.filter(
            (item) => item.report_pack > 0
          )}
          pickupCommand={pickupCommand}
          command={detail?.command}
          sjDraftId={detail?.id}
          options={pickupCommand
            ?.filter((item) => item.report_pack > 0)
            .reduce((acc, cur) => {
              acc.push({
                id: cur?.item_code,
                label: cur?.item_name
              })
              return acc
            }, [])}
          onSave={(newItem) => {
            if (editData.type === 'create') {
              setPickupCommand((prev) => [...prev, newItem])
            } else {
              setPickupCommand((prev) =>
                prev.map((item) =>
                  item.command_id === editData.command_id
                    ? { ...item, ...newItem }
                    : item
                )
              )
            }
          }}
        />

        <ModalUpdateRequest
          show={showModalUpdateRequest}
          onHide={() => handleUpdateRequest()}
          data={updateRequest}
          refreshData={() => loadData(id)}
          dataRequest={detail?.command || []}
        />

        <ModalStockAdjustment
          show={showModalDeleteRequest}
          onHide={() => {
            setShowModalDeleteRequest(false)
            setSelectedRequest(null)
          }}
          size="md"
          title=""
        >
          <Modal.Body>
            <div className="d-flex justify-content-center py-2 my-2">
              <div className="d-flex flex-column justify-content-center">
                <div className="d-flex justify-content-center">
                  <AlertIcon width={131} height={130} />
                </div>
                <div className="text-center my-3">
                  <h6 style={{ fontSize: '15px' }}>
                    Are you sure deleted request, data permanently delete?
                  </h6>
                </div>
              </div>
            </div>
            <Modal.Footer className="mt-3">
              <CustomCloseButton
                onClick={() => {
                  setShowModalDeleteRequest(false)
                  setSelectedRequest(null)
                }}
                text="Cancel"
              />
              <CustomButton
                onClick={() => handleDeleteRequest()}
                variant={loadingDeleteRequest ? 'secondary' : 'danger'}
                disabled={loadingDeleteRequest}
                text={!loadingDeleteRequest ? 'Delete' : 'Deleting...'}
                classNameValue={`text-white ${
                  loadingDeleteRequest ? 'opacity-25' : ''
                }`}
              />
            </Modal.Footer>
          </Modal.Body>
        </ModalStockAdjustment>
      </Container>
    </>
  )
}

export default Detail
